import React, { useEffect, useState } from 'react'
import './App.css'
import Error from './components/Error'
import LoginApi from './services/api/Login'
import ErrorBoundary from './components/ErrorBoundary'
import GlobalState from './context/GlobalState'
import Routing from './components/Routing'
import queryString from 'query-string'

const App = () => {
  const [error, setError] = useState(null)
  const [isLoaded, setIsLoaded] = useState(false)
  const [params] = useState(queryString.parse(window.location.search))

  const TOKEN_REFRESH_INTERVAL = 300000 // 5min

  useEffect(() => {
    login()
    return () => null
  }, [])

  useEffect(() => {
    const intervalId = setInterval(function () {
      login()
    }, TOKEN_REFRESH_INTERVAL)

    return () => {
      clearInterval(intervalId)
    }
  }, [])

  async function login () {
    const loginApi = new LoginApi()
    loginApi.post(params)
      .then(res => res.json())
      .catch((error) => {
        setIsLoaded(true)
        setError('API is not reachable. Error message: ' + error)
      })
      .then((result) => {
        if (result) {
          if (
            (Object.keys(result).includes('short_code') && result.short_code <= '400') ||
            Object.keys(result).includes('token')
          ) {
            sessionStorage.setItem('token', result.token)
            setIsLoaded(true)
          } else {
            setError(result)
            setIsLoaded(false)
          }
        }
      },
      (error) => {
        setError(error)
        setIsLoaded(false)
      })
  }

  if (!isLoaded) {
    return null
  }

  if (error) {
    return (
      <ErrorBoundary>
        <Error error={error} />
      </ErrorBoundary>
    )
  } else {
    return (
      <ErrorBoundary>
        <GlobalState params={params}>
          <Routing params={params} />
        </GlobalState>
      </ErrorBoundary >
    )
  }
}

export default App
